<h1 mat-dialog-title class="text-center mb-0">Phone number selection</h1>

<mat-divider></mat-divider>

<mat-dialog-content class="mt-1">
    <div *ngIf="!isLoading">
        <div class="d-flex justify-content-around" >
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Filter by country</mat-label>
                <mat-select [formControl]="countrySelectedValue" (selectionChange)="applyFilter()">
                    <mat-option *ngFor="let country of countries" [value]="country">{{country}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Filter by region</mat-label>
                <mat-select [formControl]="regionSelectedValue" (selectionChange)="applyFilter()">
                    <mat-option *ngFor="let region of regions" [value]="region">{{region}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="mb-4">
            <h3 class="m-0">Advanced research</h3>
            <mat-checkbox [formControl]="tollFreeSelectedValue" (change)="applyTollFreeFilter()">Toll Free</mat-checkbox>
        </div>
    </div>

    <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>

    <div class="mat-elevation-z8" [hidden]="isLoading">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Phone number Column -->
            <ng-container matColumnDef="Number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone number</th>
                <td mat-cell *matCellDef="let row"> {{row.phoneNumber}} </td>
            </ng-container>

            <!-- Locality Column -->
            <ng-container matColumnDef="Locality">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Locality</th>
                <td mat-cell *matCellDef="let row"> {{row.locality}} </td>
            </ng-container>

            <!-- Region Column -->
            <ng-container matColumnDef="Region">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Region</th>
                <td mat-cell *matCellDef="let row"> {{row.region}} </td>
            </ng-container>

            <!-- Country Column -->
            <ng-container matColumnDef="Country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
                <td mat-cell *matCellDef="let row"> {{row.isoCountry}} </td>
            </ng-container>

            <!-- # Column -->
            <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button color="primary" (click)="onBuyClicked(row)">Buy</button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            <!-- Row shown when there is no matching data. -->
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
            </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users"></mat-paginator>
    </div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions class="d-flex justify-content-around mt-1">
    <button mat-raised-button mat-dialog-close class="w-25" color="warn">Close</button>
</mat-dialog-actions>